import type { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

// PL doesn't supply the Product-based tracking context; the gallery only uses it for analytics, so
// an empty object is safe (tracking is best-effort, not required to render).
export const EMPTY_PRODUCT_PROPERTIES = {} as ProductProperties

// Start prefetching the next gallery page once the user is within this many images of the end,
// so the next batch is usually loaded before they swipe past the last loaded image.
export const GALLERY_PREFETCH_THRESHOLD = 3
export const GALLERY_PAGE_SIZE = 100

// Page size for the full review list — mirrors the legacy non-PL pageSize and the widget's limit.
export const REVIEWS_LIST_PAGE_SIZE = 4
